import TopNav from "ui/dashboard/topnav";
import {
  SvgTeamAIAgentAGI,
  SvgVirtualGuard,
  SvgTeamAIAgentVG,
  SvgContactPhone,
  SvgTeamAIAgentWatcher,
  SvgBell,
} from "ui/svgs";
export default function TeamAIAgent() {
  return (
    <div
      className="profile-page flex flex-col items-center h-full mr-6 mb-6"
      style={{ height: "calc(100% - 24px)" }}
    >
      <TopNav title="Team of AI Agent" />
      <div className="flex flex-col gap-8 items-center w-full overflow-y-auto bg-white rounded-3xl pt-[60px] flex-grow">
        <div className="w-[800px]">
          <div className="bg-[#FAFAFA] rounded-3xl h-[93px] w-full flex py-8 pl-8 items-center">
            <p className="bg-[#179954] text-white font-semibold px-1 mr-8 rounded-[4px] text-nowrap">
              001
            </p>
            <div className="w-[42px] h-[42px] flex items-center justify-center">
              <SvgTeamAIAgentAGI width={37} />
            </div>

            <p className="font-semibold pl-1 w-[114px]">AGI</p>
            <p className="font-semibold w-[100px]">Class D</p>
            <p className="w-[360px] tex-sm">Your Ultimate Super Intelligence</p>
            <p className="text-nowrap">Credit: </p>
            <p className="ml-1 font-semibold text-nowrap w-[40px]">1</p>
          </div>
          <div className="bg-[#FAFAFA] rounded-3xl h-[93px] w-full flex py-8 pl-8 items-center mt-6">
            <p className="bg-[#179954] text-white font-semibold px-1 mr-8 rounded-[4px] text-nowrap">
              002
            </p>
            <div className="w-[42px] h-[42px] flex items-center justify-center">
              <SvgVirtualGuard width={29} />
            </div>
            <p className="font-semibold pl-1 w-[114px]">Inspector</p>
            <p className="font-semibold w-[100px]">Class A</p>
            <p className="w-[360px] tex-sm">Patrol like a Guard</p>
            <p className="text-nowrap">Credit: </p>
            <p className="ml-1 font-semibold w-[40px] text-nowrap">1</p>
          </div>
          <div className="bg-[#FAFAFA] rounded-3xl h-[93px] w-full flex py-8 pl-8  items-center mt-6">
            <p className="bg-[#179954] text-white font-semibold px-1 mr-8 rounded-[4px] text-nowrap">
              003
            </p>
            <div className="w-[42px] h-[42px] flex items-center justify-center">
              <SvgTeamAIAgentVG width={29} />
            </div>
            <p className="font-semibold pl-1 w-[114px]">Virtual Guard</p>
            <p className="font-semibold w-[100px]">Class B</p>
            <p className="w-[360px] tex-sm">
              Auto Response to Any Suspicious Activity
            </p>
            <p className="text-nowrap">Credit: </p>
            <p className="ml-1 font-semibold text-nowrap w-[40px]">1</p>
          </div>

          <div className="bg-[#FAFAFA] rounded-3xl h-[93px] w-full flex py-8 pl-8  items-center mt-6">
            <p className="bg-[#179954] text-white font-semibold px-1 mr-8 rounded-[4px] text-nowrap">
              004
            </p>
            <div className="w-[42px] h-[42px] flex items-center justify-center">
              <SvgBell width={"24"} className="" />
            </div>
            <p className="font-semibold pl-1 w-[114px]">Processor</p>
            <p className="font-semibold w-[100px]">Class A</p>
            <p className="w-[360px] tex-sm">Process Al Alert from Camera</p>
            <p className="text-nowrap">Credit: </p>
            <p className="ml-1 font-semibold text-nowrap w-[40px]">1</p>
          </div>

          <div className="bg-[#FAFAFA] rounded-3xl h-[93px] w-full flex py-8 pl-8  items-center mt-6">
            <p className="bg-[#179954] text-white font-semibold px-1 mr-8 rounded-[4px] text-nowrap">
              005
            </p>
            <div className="w-[42px] h-[42px] flex items-center justify-center">
              <SvgTeamAIAgentAGI width={37} />
            </div>
            <p className="font-semibold pl-1 w-[114px]">Al Assistant</p>
            <p className="font-semibold w-[100px]">Class C</p>
            <p className="w-[360px] tex-sm">Your JAVIS</p>
            <p className="text-nowrap">Credit: </p>
            <p className="ml-1 font-semibold text-nowrap w-[40px]">1</p>
          </div>

          <div className="bg-[#FAFAFA] rounded-3xl h-[93px] w-full flex py-8 pl-8  items-center mt-6">
            <p className="bg-[#179954] text-white font-semibold px-1 mr-8 rounded-[4px] text-nowrap">
              006
            </p>
            <div className="w-[42px] h-[42px] flex items-center justify-center">
              <SvgContactPhone width={"23"} className="" />
            </div>
            <p className="font-semibold pl-1 w-[114px]">Caller</p>
            <p className="font-semibold w-[100px]">Class C</p>
            <p className="w-[360px] tex-sm">
              Help you communicate with the Team Member
            </p>
            <p className="text-nowrap">Credit: </p>
            <p className="ml-1 font-semibold text-nowrap w-[40px]">1</p>
          </div>
          <div className="bg-[#FAFAFA] rounded-3xl h-[93px] w-full flex py-8 pl-8  items-center mt-6">
            <p className="bg-[#179954] text-white font-semibold px-1 mr-8 rounded-[4px] text-nowrap">
              007
            </p>
            <div className="w-[42px] h-[42px] flex items-center justify-center">
              <SvgTeamAIAgentWatcher width={23} />
            </div>
            <p className="font-semibold pl-1 w-[114px]">Watcher</p>
            <p className="font-semibold w-[100px]">Class A</p>
            <p className="w-[360px] tex-sm">
              Help you spot any similar events in the future
            </p>
            <p className="text-nowrap">Credit: </p>
            <p className="ml-1 font-semibold text-nowrap w-[40px]">1</p>
          </div>
        </div>
      </div>
    </div>
  );
}
